export const getArtistImageById = (id: string) => {
  return new URL(
    `g/${id}?s=small`,
    process.env.REACT_APP_ASSETS_ROCK_PATH.replace(/([^\/])$/, "$1/"),
  ).toString();
};
